// Node globals required by WalletConnect under CRA/webpack 5 (no auto-polyfills).
// This module must be imported BEFORE any wagmi/walletconnect code.
import { Buffer } from "buffer";
import process from "process";

if (typeof window !== "undefined") {
  if (!window.Buffer) window.Buffer = Buffer;
  if (!window.process) window.process = process;
  if (!window.global) window.global = window;
}
